import sanityClient from '@sanity/client';

const isDev = process.env.NODE_ENV === 'development';

export const sanity = sanityClient({
	accessToken: process.env.NEXT_PUBLIC_SANITY_TOKEN,
	projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
	dataset: process.env.NEXT_PUBLIC_SANITY_DATASET,
	isPreview: isDev,
	watch: false,
	useCdn: false,
	apiVersion: "2021-08-31"
});

export default sanity;
